import React, { Component } from 'react'
import Modal from 'react-modal'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import CompanyNameUpdateModalUI from './CompanyNameUpdateModalUI.js'

class CompanyNameUpdateModalSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      successMsg: null,
      errorList: null,
      // form events
      submitted: false,
      // form field
      cinName: this.props.account.cinName || '',
      nameError: null,
      //
      incorporationDate: '',
      incorporationDateError: null,
      //
      cinNumber: this.props.account.cinNumber || '',
      cinNumberError: null,
    }
  }

  render() {
    return (
      <CompanyNameUpdateModalUI
        context={this.props.context}
        errorList={this.state.errorList}
        successMsg={this.state.successMsg}
        setErrorList={this.setErrorList}
        // modes
        updateMode={this.props.updateMode}
        submitted={this.state.submitted}
        // event handlers
        onSubmit={this.onSubmit}
        onCancelClick={this.props.onCancelClick}
        // form fields
        cinName={this.state.cinName}
        onNameChange={(event) => { this.setState({ cinName: event.target.value }) }}
        nameError={this.state.nameError}
        setNameError={(error) => { this.setState({ nameError: error }) }}
        //
        incorporationDate={this.state.incorporationDate}
        onIncorporationDateChange={(selectedDateISO) => { this.setState({ incorporationDate: selectedDateISO }) }}
        incorporationDateError={this.state.incorporationDateError}
        setIncorporationDateError={(error) => { this.setState({ incorporationDateError: error }) }}
        //
        cinNumber={this.state.cinNumber}
        onCinNumberChange={(event) => { this.setState({ cinNumber: event.target.value }) }}
        cinNumberError={this.state.cinNumberError}
        setCinNumberError={(error) => { this.setState({ cinNumberError: error }) }}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    Modal.setAppElement('body')

  }

  onSubmit = () => {
    let submitted = this.state.submitted
    if (submitted)
      return

    this.setState({
      successMsg: null,
      errorList: [],
      submitted: true
    })

    let context = this.props.context
    RestApiUtils.put(this.props.context,
      `/api/su/accounts/${this.props.account.accountId}/cinName`,
      this.onSubmitCallback,
      {
        cinName: this.state.cinName,
        incorporationDate: this.state.incorporationDate,
        cinNumber: this.state.cinNumber
      }
    )
  }

  onSubmitCallback = (response) => {
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
    })

    this.setState({
      successMsg: response.success,
      errorList: errorList,
      submitted: false
    })

    if (response.errorList.length === 0) {
      setTimeout(() => {
        this.setState({
          successMsg: null
        })
        this.props.onCancelClick()
        this.props.onRefreshClick('noBusy')
      }, 2000)
    }
  }

  setErrorList = (errorList) => {
    this.setState({ errorList: errorList })
  }
}

export default CompanyNameUpdateModalSF
